import React from 'react';
import Text from '../../Asset/Text/Text';
import './Instruction.scss';

const Instruction = ({ id, simple }) => {
  return (
    <div className={`instructions${simple ? ' simple' : ''}`}>
      {simple ? (
        <Text id={id} md />
      ) : (
        <div className="alert">
          <div className="alert__icon icon-info-outline"></div>
          <div className="alert__message">
            <Text id={id} md />
          </div>
        </div>
      )}
    </div>
  );
};

export default Instruction;
